import React from 'react';
import { Modal, Grid, Button } from 'semantic-ui-react';
import CiscoChat from './CiscoChat';
import PhoneNumber from './PhoneNumber';

const ContactUsModal = ({ trigger, open, onOpen, onClose }) => {
	return (
		<Modal size='tiny' trigger={trigger} open={open} onOpen={onOpen} onClose={onClose}>
			<Modal.Header>Contact Us</Modal.Header>
			<Modal.Content>
				<Grid className='contact' columns='equal'>
					<Grid.Row>
						<Grid.Column>
							
							<div className='bold'>Telephone Numbers:</div>
							 <PhoneNumber phoneNumber={'800.477.1660'}></PhoneNumber> 
							<div>800.468.8084 (fax)</div>
						</Grid.Column>
						<Grid.Column>
							<div className='bold'>Mailing Address</div>
							<div>P.O. Box 527</div>
							<div>Indianapolis, IN 46206</div>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						<Grid.Column>
							<div className='bold'>Street Address</div>
							<div>10 West 106th Street</div>
							<div>Indianapolis, IN 46290</div>
						</Grid.Column>
						<Grid.Column>
							<CiscoChat />
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</Modal.Content>
			<Modal.Actions>
				<Button icon='close' content='Close' onClick={onClose}></Button>
			</Modal.Actions>
		</Modal>
	);
};

export default ContactUsModal;
